import { gql } from '@apollo/client';

// itemType is the item_type_enum value in GraphQL form (UPPER_SNAKE_CASE).
export const QUOTE_SOP_QUERY = gql`
  query QuoteSop($itemType: ItemTypeEnum!, $domainId: Int!) {
    quoteSopByItemType(itemType: $itemType) {
      itemType
      sopMarkdown
      sourceCommit
      updatedAt
    }
    # Append-only history: newest row is the current note.
    allQuoteSopNotes(
      condition: { domainId: $domainId, itemType: $itemType }
      orderBy: [CREATED_AT_DESC, ID_DESC]
    ) {
      nodes {
        id
        body
        createdAt
        createdBy
        userByCreatedBy {
          id
          username
        }
      }
    }
  }
`;

export const CREATE_QUOTE_SOP_NOTE_MUTATION = gql`
  mutation CreateQuoteSopNote($input: CreateQuoteSopNoteInput!) {
    createQuoteSopNote(input: $input) {
      quoteSopNote {
        id
      }
    }
  }
`;
